import { NullableDateString, parseDate } from '@superdispatch/dates';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useInsurances } from 'shared/modules/carrier-profile/core/CargoInsuranceList';
import { CarrierSettings } from 'shared/settings/CarrierSettingsAPI';

export function getInsuranceExpiring(expirationDate: NullableDateString) {
  const diffDate = parseDate(expirationDate).diffNow('days');
  return diffDate.isValid && diffDate.days <= 30;
}

/*
 * Check if the insurance is expired for carriers
 * that was declined or revoked for reason not related to insurance itself.
 */
export function getInsuranceExpiredForUnverifiedCarrier(
  carrier: CarrierSettings['carrier'],
) {
  const certDate = parseDate(carrier.cargo_insurance_expiration_date);
  return (
    certDate < DateTime.now().startOf('day') &&
    (carrier.verification_status === 'revoked' ||
      carrier.verification_status === 'declined')
  );
}

export function useCargoInsuranceExpiring() {
  const { currentInsurance, renewalInsurance } = useInsurances();

  return useMemo(() => {
    return {
      isInsuranceExpiring:
        currentInsurance?.expiration_date &&
        getInsuranceExpiring(currentInsurance.expiration_date),
      isRenewalInsuranceUploaded: !!renewalInsurance,
      isRenewalInsuranceVerified: !!renewalInsurance?.is_verified,
    };
  }, [currentInsurance, renewalInsurance]);
}
